<template>
  <div>
    <headEnterprise></headEnterprise>
    <banner :banner="bannerUrl"></banner>
	<enterTitle></enterTitle>
    <div class="w80 mb-60 mt-30">
      <el-container>
        <el-aside width="330px">
          <base-info @goCollection="goCollection(7)"></base-info>
          <!-- <div class="saide_middle">
            <div class="saide_mater">
              <p>产品分类</p>
            </div>
            <div class="saide_tree">
              <el-tree :data="data" show-checkbox node-key="id"> </el-tree>
            </div>
          </div> -->
        </el-aside>
        <el-main>
          <div>
            <div v-if="videoUrl">
              <contTitle :obj="obj" :contTitle="contTitle"></contTitle>
              <div class="introduce mt-20">
                <videoPlayer :videoUrl="videoUrl"></videoPlayer>
                <div class="video_text">{{userInfo.publicizeVideoDesc}}</div>
              </div>

            </div>



            <contTitle
              class="mt-20"
              :obj="obj"
              :contTitle="contTitle2"
            ></contTitle>
            <div class="introduce_cont mt-20" v-html="userInfo.detail"></div>
          </div>
        </el-main>
      </el-container>
    </div>
      <footCom></footCom>
  </div>
</template>
<script>
import{addCollection} from "@/api/coment"
import footCom from "../../common/footCom";
import headEnterprise from "../../common/headEnterprise"
import banner from "../../common/banner";
import needsList from "../../components/needsList";
import contTitle from "../../common/contTitle";
import baseInfo from "@/components/companyintroCard"
import enterTitle from "@/common/enterTitle"
import videoPlayer from '@/components/videoPlayer'
export default {
  components: { footCom,headEnterprise,banner, needsList, contTitle,baseInfo ,enterTitle,videoPlayer},
  data() {
    return {
      contTitle: "企业宣传片",
      contTitle2: "企业介绍",
      banner: {
        title: "企业介绍",
        isShow: false,
        isColor: true,
        type:'',
        usertype:'',
        companytype:'',
      },
      obj:{},
      data: [],
	  videoUrl:''
    };
  },
  created(){
     this.$store.dispatch("company/getBaseInfo");
  },
  computed: {
    userInfo() {
      return this.$store.getters.companyInfo;
    },
     bannerUrl() {
      return { bannerUrl: this.$store.getters.companyInfo.banner };
    },
  },
  watch:{
    userInfo:{
      handler(val){
        this.videoUrl = val.publicizeVideo;
      },
      immediate:true
    }
  },
  methods: {
    //产品收藏
    goCollection(goodsType){
      let params ={
        goodsId:this.id,
        goodsType:goodsType
      }
      addCollection(params).then((res)=>{
        if(res.code ==0){
          this.$message({
            message: '收藏成功！',
            type: 'success'
          });
        }
      }).catch((err)=>{})
    },
  },
};
</script>
<style  scoped>
.mt-20 {
  margin-top: 20px;
}
.el-aside {
  background: white;
  height: auto;
}
.aside_left {
  height: 532px;
  background: #ffffff;
  border: 1px solid #ededed;
  padding: 20px 20px;
}
.left_top {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.portrait {
  width: 107px;
  height: 107px;
  background: #ffffff;
  border: 1px solid #ededed;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.portrait img {
  width: 80px;
  height: 80px;
  border-radius: 50%;
}
.wire {
  margin-top: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #999999;
}
.wire p {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
}
.left_bat {
  text-align: left;
  margin-top: 20px;
  margin-left: 30px;
}
.left_bat p {
  align-items: baseline;
}
.left_bat p span:first-child {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 30px;
}
.left_bat p span:last-child {
  flex: 1;
  margin-left: 10px;
  margin-right: 20px;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
}
.left_far {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-right: 15px;
}
.left_far img {
  width: 17px;
  height: 16px;
  margin-right: 10px;
}
.left_bartext {
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}

.saide_middle {
  margin-top: 30px;
  background: #f8f8f8;
  color: #333;
  text-align: center;
  border-top: 2px solid #99cf2a;
  padding: 15px 15px;
  text-align: left;
}
.saide_mater {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 20px;
  border-bottom: 1px dashed #e1e1e1;
}
.saide_mater p {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
}
.saide_mater span {
  cursor: pointer;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
}

.el-tree {
  background: #f8f8f8;
}

.wires {
  border-bottom: 1px solid #eeeeee;
  margin-top: 20px;
}

.video_text{
  margin-top: 10px;
  text-align: left;
  font-size: 14px;
  height: 80px;
  color: #666666;
  overflow: hidden;
}
.introduce_cont {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  line-height: 24px;
  text-align: left;
  max-height: 500px;
  overflow: auto;
}
.introduce_cont >>>p img{
  width: 100% !important;
  object-fit: cover;
}
.introduce_cont >>>div a img{
  width: 100% !important;
}
.mt-10 {
  margin-top: 10px;
}
.mb-60 {
  margin-bottom: 60px;
}
</style>



// WEBPACK FOOTER //
// src/view/company/corporate_introduce.vue